<div class="biz-page">
    <div class="rana-page-header">
        <div>
            <h1 class="rana-page-title">{{ editingId ? 'Edit your business' : 'Add your business' }}</h1>
            <p class="rana-page-subtitle mb-0">The more you share, the easier it is for other members to find and trust you.</p>
        </div>
    </div>

    <div *ngIf="!allowed" class="alert alert-info mt-3">
        Only RANA members can add a business. You can still browse the directory.
        <a routerLink="/biz-directory">Back to the directory</a>
    </div>

    <form *ngIf="allowed" [formGroup]="form" (ngSubmit)="save()" class="mt-3">

        <h5 class="biz-form-heading">About the business</h5>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="font-weight-600 size-14">Business name *</label>
                <input type="text" formControlName="businessName" class="form-style big with-border" maxlength="120"
                       [class.is-invalid]="form.get('businessName')?.invalid && form.get('businessName')?.touched">
            </div>
            <div class="col-md-6 mb-3">
                <label class="font-weight-600 size-14">Category *</label>
                <select formControlName="industry" class="form-style big with-border"
                        [class.is-invalid]="form.get('industry')?.invalid && form.get('industry')?.touched">
                    <option value="">Select a category</option>
                    <optgroup *ngFor="let g of categories" [label]="g.group">
                        <option *ngFor="let c of g.categories" [value]="c.code">{{ c.name }}</option>
                    </optgroup>
                </select>
            </div>
            <div class="col-12 mb-3">
                <label class="font-weight-600 size-14">Tagline <span class="text-muted">(one line, up to 140 characters)</span></label>
                <input type="text" formControlName="tagline" class="form-style big with-border" maxlength="140"
                       placeholder="e.g. Fresh mithai and catering for every celebration">
            </div>
            <div class="col-12 mb-3">
                <label class="font-weight-600 size-14">Description</label>
                <app-rt-editor formControlName="description" name="description" placeholder="Tell members what you do, your story, what makes you different"></app-rt-editor>
            </div>
            <div class="col-12 mb-3">
                <label class="font-weight-600 size-14">What you offer <span class="text-muted">(comma separated, up to 10)</span></label>
                <input type="text" class="form-style big with-border" [ngModelOptions]="{standalone: true}" [(ngModel)]="offeringsText"
                       placeholder="e.g. catering, wedding sweets, gift boxes">
            </div>
        </div>

        <h5 class="biz-form-heading">Where and how big</h5>
        <div class="row">
            <div class="col-md-4 mb-3">
                <label class="font-weight-600 size-14">City</label>
                <input type="text" formControlName="city" class="form-style big with-border" maxlength="80">
            </div>
            <div class="col-md-4 mb-3">
                <label class="font-weight-600 size-14">State</label>
                <select formControlName="state" class="form-style big with-border">
                    <option value="">Select</option>
                    <option *ngFor="let s of states" [value]="s.code">{{ s.name }}</option>
                </select>
            </div>
            <div class="col-md-4 mb-3">
                <label class="font-weight-600 size-14">Who do you serve?</label>
                <select formControlName="serviceArea" class="form-style big with-border">
                    <option value="">Select</option>
                    <option *ngFor="let a of serviceAreas" [value]="a.value">{{ a.label }}</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label class="font-weight-600 size-14">Team size</label>
                <select formControlName="size" class="form-style big with-border">
                    <option value="">Select</option>
                    <option *ngFor="let s of sizes" [value]="s.value">{{ s.label }}</option>
                </select>
            </div>
            <div class="col-md-6 mb-3">
                <label class="font-weight-600 size-14">Year started</label>
                <input type="number" formControlName="yearStarted" class="form-style big with-border" [min]="1900" [max]="thisYear"
                       [class.is-invalid]="form.get('yearStarted')?.invalid && form.get('yearStarted')?.touched">
            </div>
        </div>

        <h5 class="biz-form-heading">Contact <span class="size-13 text-muted font-weight-normal">(shown to logged-in visitors only)</span></h5>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="font-weight-600 size-14">Website</label>
                <input type="text" formControlName="website" class="form-style big with-border" placeholder="www.example.com"
                       [class.is-invalid]="form.get('website')?.invalid && form.get('website')?.touched">
                <div class="text-danger size-12 mt-1" *ngIf="form.get('website')?.invalid && form.get('website')?.touched">Please enter a valid web address</div>
            </div>
            <div class="col-md-6 mb-3">
                <label class="font-weight-600 size-14">Business email</label>
                <input type="email" formControlName="email" class="form-style big with-border"
                       [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched">
            </div>
            <div class="col-md-6 mb-3">
                <label class="font-weight-600 size-14">Phone</label>
                <input type="text" formControlName="phone" class="form-style big with-border"
                       [class.is-invalid]="form.get('phone')?.invalid && form.get('phone')?.touched">
            </div>
            <div class="col-md-6 mb-3">
                <label class="font-weight-600 size-14">WhatsApp number</label>
                <input type="text" formControlName="whatsapp" class="form-style big with-border"
                       [class.is-invalid]="form.get('whatsapp')?.invalid && form.get('whatsapp')?.touched">
            </div>
            <div class="col-md-4 mb-3">
                <label class="font-weight-600 size-14">LinkedIn</label>
                <input type="text" formControlName="linkedin" class="form-style big with-border" placeholder="linkedin.com/company/...">
            </div>
            <div class="col-md-4 mb-3">
                <label class="font-weight-600 size-14">Instagram</label>
                <input type="text" formControlName="instagram" class="form-style big with-border" placeholder="instagram.com/...">
            </div>
            <div class="col-md-4 mb-3">
                <label class="font-weight-600 size-14">Facebook</label>
                <input type="text" formControlName="facebook" class="form-style big with-border" placeholder="facebook.com/...">
            </div>
        </div>

        <h5 class="biz-form-heading">Connect with members</h5>
        <div class="row">
            <div class="col-12 mb-3">
                <label class="font-weight-600 size-14 d-block">We are looking for</label>
                <label class="mr-3" *ngFor="let l of lookingForOptions">
                    <input type="checkbox" [checked]="selectedLooking.has(l.value)" (change)="toggleLooking(l.value)"> {{ l.label }}
                </label>
            </div>
            <div class="col-12 mb-3">
                <label class="font-weight-600 size-14">RANA member offer <span class="text-muted">(optional)</span></label>
                <input type="text" formControlName="memberOffer" class="form-style big with-border" maxlength="200"
                       placeholder="e.g. 10% off for RANA members">
            </div>
            <div class="col-12 mb-3">
                <label>
                    <input type="checkbox" formControlName="mentorAvailable">
                    I am happy to mentor members who want to start a similar business
                </label>
            </div>
        </div>

        <h5 class="biz-form-heading">Logo and photos <span class="size-13 text-muted font-weight-normal">(jpg, png, gif or webp, up to 5 MB each)</span></h5>
        <div class="row">
            <div class="col-md-4 mb-3">
                <label class="font-weight-600 size-14">Logo</label>
                <input type="file" class="form-control-file" accept="image/png,image/jpeg,image/gif,image/webp" (change)="onLogoPicked($event)">
                <img *ngIf="logoPreview || existingLogo" [src]="logoPreview || existingLogo" class="biz-form-logo mt-2" alt="Logo preview">
            </div>
            <div class="col-md-8 mb-3">
                <label class="font-weight-600 size-14">Photos <span class="text-muted">({{ photoSlotsLeft }} left)</span></label>
                <input type="file" class="form-control-file" multiple accept="image/png,image/jpeg,image/gif,image/webp"
                       [disabled]="photoSlotsLeft <= 0" (change)="onPhotosPicked($event)">
                <div class="biz-form-photos mt-2">
                    <div class="biz-form-photo" *ngFor="let url of existingPhotos">
                        <img [src]="url" alt="">
                        <button type="button" class="biz-photo-remove" (click)="removeExistingPhoto(url)" aria-label="Remove photo">&times;</button>
                    </div>
                    <div class="biz-form-photo" *ngFor="let url of photoPreviews; let i = index">
                        <img [src]="url" alt="">
                        <button type="button" class="biz-photo-remove" (click)="removePendingPhoto(i)" aria-label="Remove photo">&times;</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="rana-detail-actions">
            <a class="rana-action-btn" [routerLink]="editingId ? ['/biz-directory', editingId] : ['/biz-directory']">
                <i class="uil uil-arrow-left"></i> Cancel
            </a>
            <button type="submit" class="btn btn-dark-primary">
                <i class="uil" [ngClass]="editingId ? 'uil-check-circle' : 'uil-plus-circle'"></i>
                {{ editingId ? 'Save changes' : 'Add business' }}
            </button>
        </div>
    </form>
</div>
